import _default from './inlineLists';
export { _default as default };
